export enum GoogleAnalyticsReportTypesEnum {
    USERS = 'USERS',
    SESSIONS = 'SESSIONS',
    UNIQUE_PAGEVIEWS = 'UNIQUE_PAGEVIEWS',
    TOTAL_PAGEVIEWS = 'TOTAL_PAGEVIEWS',
    WEB_REFERRALS = 'WEB_REFERRALS',
    SOCIAL_REFERRALS = 'SOCIAL_REFERRALS',
    EMAIL_REFERRALS = 'EMAIL_REFERRALS',
    TOTAL_REFERRALS = 'TOTAL_REFERRALS'
}
